import { render, staticRenderFns } from "./DefaultRoutesList.vue?vue&type=template&id=65a9fefa&scoped=true"
import script from "./DefaultRoutesList.vue?vue&type=script&lang=js"
export * from "./DefaultRoutesList.vue?vue&type=script&lang=js"
import style0 from "./DefaultRoutesList.vue?vue&type=style&index=0&id=65a9fefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9fefa",
  null
  
)

export default component.exports